import { render } from "./HealthView.vue?vue&type=template&id=68104f34&scoped=true"
import script from "./HealthView.vue?vue&type=script&lang=js"
export * from "./HealthView.vue?vue&type=script&lang=js"

import "./HealthView.vue?vue&type=style&index=0&id=68104f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68104f34"]])

export default __exports__